import { Component, inject } from '@angular/core'
import { UserService } from '../shared/user/user.service';
import { BaseResponse } from '@aifs-shared/common/base-response';
import { UiModalService } from '@ui/ui-modal.service';
import { TrackerTaskComponent } from '@aifs-shared/tracker/tracker-task.component';
import { Subscription } from 'rxjs';
import { TrackerButtonComponent } from '@aifs-shared/tracker/tracker-button.component';

import { MetaForm, MetaFormDisplayComponent, MetaFormService, MetaFormTextType, MetaFormUserEvent, MFValidator, MFValueChange, UserEventType } from '@aifs-metaform/public-api';
import { CfButtonComponent, CFButtonStyle, CFButtonType } from '@ui/cf-button/cf-button.component';

@Component({
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [TrackerButtonComponent, MetaFormDisplayComponent, CfButtonComponent]
})

export class ForgotPasswordComponent extends TrackerTaskComponent {
    private modalService = inject(UiModalService);
    private userService = inject(UserService);
    private metaformService = inject(MetaFormService);

    ButtonStyle = CFButtonStyle;
    ButtonType = CFButtonType;

    constructor() {
        super();
        this.requiresTask = false;
        this.setPreviousEnabled(true);
        this.createForgotForm();
    }

    override ngOnInit() {
        super.ngOnInit();

    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.formSubscription?.unsubscribe();
    }

    override stepPrevious(): boolean {
        this.router.navigateByUrl("/sign-in");
        return true;
    }

    sendReset() {
        if (this.form?.isValid()) {
            this.sendResetEmail();
        }
    }

    sendResetEmail() {
        this.isProcessing = true;
        this.userService
            .sendResetPassword(this.email)
            .subscribe({
                next: (br: BaseResponse) => {
                    if (br.resultCode === 1) {
                        this.showAlert('Request Password Reset', 'If you have an account with Camp America, you should receive a password reset email shortly.', undefined, '/sign-in');
                    } else {
                        this.showAlert('Request Password Reset', 'There was an error attempting to send a password reset email. Please try again.', br.error || 'error');
                    }
                },
                error: (e: any) => {
                    this.showAlert('Request Password Reset', 'There was an error attempting to send a password reset email. Please try again.', e);
                },
                complete: () => {
                    this.isProcessing = false;
                }
            });
    }

    onFormEvent(event: MetaFormUserEvent): void {
        switch (event.type) {
            case UserEventType.FormInitialised:
            case UserEventType.FormInvalid:
            case UserEventType.FormInvalidOnAttemptedSubmit:
                this.buttonEnabled = false;
                break;
            case UserEventType.FormValid:
                // console.log(`The form is now valid`);
                this.buttonEnabled = true;
                break;
            case UserEventType.FormSubmit:
                if (this.buttonEnabled) this.sendReset();
                break;
        }
    }

    private createForgotForm() {
        const f = this.metaformService.createForm('forgot-password', 'Forgot Password');

        f.addSection('Default');
        f.addQuestion('q_email')
            .addTextControl('email', MetaFormTextType.Email, 255, 'Email')
            .addValidator(MFValidator.Required('Please enter your email'))
            .addValidator(MFValidator.Email('Please enter your email'));

        // console.log(f.toJson());

        this.form = f;

        this.formSubscription = this.form.change$
            .subscribe({
                next: (chg: MFValueChange) => {
                    if (chg.name == 'email') {
                        this.email = chg.value;
                    }

                    this.buttonEnabled = this.form?.isValid() ?? false;
                }
            });
    }

    showAlert(title: string, explain: string, error: string | undefined = undefined, navigateToUrl: string | undefined = undefined) {
        if (navigateToUrl) {
            this.modalService.showModalInformation(title, explain).subscribe({
                next: (r: string) => {
                    this.router.navigateByUrl(navigateToUrl);
                }
            })
        } else {
            this.modalService.showModalError(title, explain);
        }
    }

    form?: MetaForm;
    buttonEnabled: boolean = false;
    formSubscription?: Subscription;
    email = '';
    isProcessing = false;
}